import React, {useEffect} from 'react';
import {Modal} from "react-bootstrap";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {createLocation, hideModal, updateLocation} from "../../redux-store/map";
import {getLocation, getLocationEdit, getModalStatus, getUserInfo} from "../../redux-store/selectors";
import pinIcon from "../../images/location.png";
import {formatLatLng} from "../../constants/FunctionJS";
import {checkUserViewer} from "../authHelpers";

const defaultValues = {
    name: "",
    description: "",
    longitude: "",
    latitude: "",
}
const LocationModal = ({installationId}) => {
    const dispatch = useDispatch();
    const modalVisibility = useSelector(getModalStatus);
    const location = useSelector(getLocation);
    const editing = useSelector(getLocationEdit);
    const userInfo = useSelector(getUserInfo)

    const {
        register,
        handleSubmit,
        formState: {},
        setValue,
        reset
    } = useForm();

    useEffect(() => {
        if (location !== null && editing) {
            for (const [key, value] of Object.entries(location)) {
                if (key === "longitude" || key === "latitude")
                    setValue(key, formatLatLng(value));
                else
                    setValue(key, value);
            }
        }
    }, [editing, location]);

    const onsubmit = (data) => {

        if (editing) {
            dispatch(updateLocation({installationId, locationId: location.id, data}));
        } else {
            dispatch(createLocation({installationId, data}))
        }
    }
    const onModalClose = () => {
        dispatch(hideModal());
        reset(defaultValues);
    }
    const handleLocationRequest = (e) => {
        e.preventDefault();
        if (!navigator.geolocation) {
            return;
        }
        const onSuccess = (position) => {
            const {
                latitude,
                longitude
            } = position.coords;
            setValue("latitude", formatLatLng(latitude));
            setValue("longitude", formatLatLng(longitude));
        }
        const onError = () => {

        }
        navigator.geolocation.getCurrentPosition(onSuccess, onError);
    }

    return (
        <Modal
            show={modalVisibility}
            onHide={onModalClose}
            backdrop="static"
            keyboard={false}
            className={"location-modal"}
        >
            <Modal.Header closeButton className={"modal-header-component"}>
                <Modal.Title>{editing ? "Ažuriranje lokacije" : "Kreiranje lokacije"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit(onsubmit)}>
                    <div className={"container"}>
                        <div className={"row mb-3"}>
                            <div className={"col-12"}>
                                <label className="mb-2 form-label" htmlFor="name">Ime lokacije</label>
                                <input disabled={checkUserViewer(userInfo)} type="text" className="form-control"
                                       name="name"
                                       required autoFocus {...register("name", {required: true})} />
                            </div>
                        </div>
                        <div className={"row mb-3"}>
                            <div className={"col-12"}>
                                <label className="form-label" htmlFor="description">Kratak opis</label>
                                <textarea disabled={checkUserViewer(userInfo)} className="form-control" rows={"5"}
                                          name="description"
                                          required {...register("description")} required={false}/>
                            </div>
                        </div>
                        <div className={"row mb-3"}>
                            <div className={"col-12 col-md-5 col-lg-5 col-xl-5 pb-2"}>
                                <label className="form-label" htmlFor="description">Dužina</label>
                                <input disabled={checkUserViewer(userInfo)} type="text" className="form-control"
                                       name="longitude"
                                       required autoFocus {...register("longitude", {required: true})}/>
                            </div>
                            <div className={"col-12 col-md-5 col-lg-5 col-xl-5 pb-2"}>
                                <label className="form-label" htmlFor="description">Širina</label>
                                <input disabled={checkUserViewer(userInfo)} type="text" className="form-control"
                                       name="latitude"
                                       required autoFocus {...register("latitude", {required: true})}/>
                            </div>
                            {checkUserViewer(userInfo) ? "" : <div className={"col-12 col-md-2 col-lg-2 col-xl-2 pb-2"}>
                                <label className="form-label" htmlFor="long/lat">Duž/Šir</label>
                                <button className={"btn location-size"} onClick={handleLocationRequest}>
                                    <img src={pinIcon}/>
                                </button>
                            </div>}
                        </div>
                        <div className={"row"}>
                            <div className={"col-12"}>
                                <div className={"modal-footer-component"}>
                                    {checkUserViewer(userInfo) ?
                                        <button className={"btn btn-modal-cancel"} onClick={onModalClose}
                                                type={"button"}>
                                            {"Zatvori"}
                                        </button> : <>
                                            <button className={"btn btn-modal-cancel"} onClick={onModalClose}
                                                    type={"button"}>
                                                {"Otkaži"}
                                            </button>
                                            <button
                                                className={"btn btn-modal-confirm"}>{editing ? "Izmjeni" : "Kreiraj"}</button>
                                        </>}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default LocationModal;